import { Box } from "@mui/material";
import { Suspense } from "react";
import { ResetPW } from "@/features/auth";

export default function ResetPasswordPage() {
	return (
		<Box
			sx={{
				marginTop: 8,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				borderRadius: 1,
				padding: 2,
			}}
		>
			<Suspense fallback={<div>Loading...</div>}>
				<ResetPW />
			</Suspense>
		</Box>
	);
}
